import {ordoroFetch} from './ordoroFetch.js'
import {stringify} from './querystring.js'

export function formatUranusURL(url, query) {
  return `${window.ORDORO_BOOTSTRAP.env.PAPPY_ENV_URANUS_URL}${url}${query ? `?${stringify(query)}` : ''}`
}

export function uranusFetch(method, url, data, options) {
  return ordoroFetch(
    method,
    formatUranusURL(url, method === 'get' && data),
    data,
    options,
  )
}

export default {
  head(url, data, options) {
    return uranusFetch('head', url, data, options)
  },
  get(url, data, options) {
    return uranusFetch('get', url, data, options)
  },
  put(url, data, options) {
    return uranusFetch('put', url, data, options)
  },
  post(url, data, options) {
    return uranusFetch('post', url, data, options)
  },
  patch(url, data, options) {
    return uranusFetch('patch', url, data, options)
  },
  delete(url, data, options) {
    return uranusFetch('delete', url, data, options)
  },
}
